<template>
 <div class="body">
   <table width="100%" cellpadding="0" cellspacing="0" border="0">
  <tbody>
    <tr>
      <td width="*">&nbsp;</td>
      <td width="1000">
      <br>
<header>
  <div align="center">

            <h3><strong><router-link to="/" class="backlink"><svg class="svg-icon" viewBox="0 -3 20 20">
							<path fill="none" d="M8.388,10.049l4.76-4.873c0.303-0.31,0.297-0.804-0.012-1.105c-0.309-0.304-0.803-0.293-1.105,0.012L6.726,9.516c-0.303,0.31-0.296,0.805,0.012,1.105l5.433,5.307c0.152,0.148,0.35,0.223,0.547,0.223c0.203,0,0.406-0.08,0.559-0.236c0.303-0.309,0.295-0.803-0.012-1.104L8.388,10.049z"></path>
						</svg> back to main page</router-link></strong></h3>
            <h3><i>S. D. Escobedo</i></h3>
            <h1>Physics</h1>
            <h1>Personal research website</h1>
            <h3>
              <b>
                <a class="link_author" href="/philosophy">Philosophy</a>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a class="link_author" href="/mathematics">Mathematics</a>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a class="link_author" href="/aerospace">Aesrospace</a>
                <br><br>
                <div style="font-size:12px"></div>
              </b>
            </h3>
			  <br>
    </div>
</header>

<section>
  <nav>
    <h4>Research lines</h4>
    <ul>
      <li><router-link to="/physics">Ontology of relativity</router-link></li>

    </ul>
    <h4>Topics of interest</h4>
    <ul>
      <li><router-link to="/ParticlePhysics">Particle physics</router-link></li>
      <li><router-link to="/NuclearFusion">Nuclear fusion</router-link></li>
      <li><router-link to="/Cosmology">Cosmology</router-link></li>
      <li><router-link to="/MultiMessenger">Multi-messenger astronomy</router-link></li>
      <li><router-link to="/Astrophysics">Astrophysics</router-link></li>
      <li><router-link to="/PlanetaryScience">Planetary science</router-link></li>
    </ul>

    <small>
    <h4>Other research areas</h4>
      <a href="/philosophy">Philosophy</a> •
      <a href="/mathematics">Mathematics</a> •
      <a href="/aerospace">Aerospace</a>
    </small>
  </nav>

  <router-view/>

</section>

  <footerModule/>
   <td width="*">&nbsp;</td>
   </tr>
  </tbody>
</table>

</div>
</template>

<script>

import footerModule from '../components/footer.vue'

export default {
   name: 'Research_Philosophy',
   components: {footerModule}
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

body {
  font-family: Arial, Helvetica, sans-serif;
  background-color:rgb(63, 63, 63);
}

/* Style the header */
header {
  background-color: rgb(255, 255, 255);
  padding: 10px;
  text-align: center;
  font-size: 20px;
  color: rgb(63, 63, 63);
}

/* Create two columns/boxes that floats next to each other */
nav {
  float: left;
  width: 25%;
  height: 600px;
  background: #ccc;
  padding: 20px;
}

nav a{
  text-decoration: none;
}
nav a:hover{
  color: brown;
}


/* Style the list inside the menu */
nav ul {
  list-style-type: none;
  padding: 0;
}

article {
  float: left;
  padding: 20px;
  width: 70%;
  background-color: #f1f1f1;
  height: 70%;
}

/* Clear floats after the columns */
section::after {
  content: "";
  display: table;
  clear: both;
}

/* Responsive layout - makes the two columns/boxes stack on top of each other instead of next to each other, on small screens */
@media (max-width: 600px) {
  nav, article {
    width: 100%;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Research_physics.vue